<template>
  <div id="driver_info" class="right_col" role="main" ref="formContainer">
    <el-row :gutter="20">
      <el-col :span="6">
        <el-row :gutter="20">
          <el-col>
            <button
              @click="onDriverMsg"
              class="btn btn-primary col-md-12 fontSize16"
            >
              即時訊息
            </button>
          </el-col>
        </el-row>
        <hr />
        <el-row :gutter="20" style="margin-bottom: 1rem">
          <el-col>
            <el-input
              class="search-placeholder-bold"
              v-model="kw"
              placeholder="隊編/呼號、電話、上車地點、車牌、備註"
            />
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col>
            <el-button-group v-if="showResumeTimerBtn">
              <el-button class="search-btn" @click="searchKw">搜尋</el-button>
              <el-button @click="resumeTimer" type="danger">
                清除關鍵字
              </el-button>
            </el-button-group>
            <el-button v-else class="search-btn" @click="searchKw">
              搜尋
            </el-button>
          </el-col>
        </el-row>
        <hr />
        <el-row :gutter="20">
          <el-col>
            <Map ref="map" class="col-md-12 col-sm-12" style="height: 400px" />
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col>
            <DriverInfo />
          </el-col>
        </el-row>
      </el-col>
      <el-col :span="18">
        <Main ref="main" @open-modal="openModal" />
      </el-col>
    </el-row>
    <div
      id="hailingListModal"
      class="modal fade bd-example-modal-lg"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
    >
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h3 class="modal-title" id="exampleModalLabel">單筆派車訂單訊息</h3>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
              @click="onCloseModal"
            >
              <span>&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <BillModal ref="hailModal" :default-msg-list="defaultMsgList" />
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
              @click="onCloseModal"
            >
              關閉
            </button>
          </div>
        </div>
      </div>
    </div>
    <!--查看司機即時訊息modal-->
    <DriverMsgModal />
  </div>
</template>

<script>
import { reqDefaultMsg } from '@/api/hailState'
import { orderRemind } from '@/utils/helper'
import { Notification } from 'element-ui'
import { mapMutations, mapActions } from 'vuex'
import {
  Main,
  Map,
  DriverInfo,
  BillModal,
  DriverMsgModal,
} from './components-v2'

export default {
  name: 'HailStateV2',
  components: {
    Main,
    Map,
    DriverInfo,
    BillModal,
    DriverMsgModal,
  },
  data() {
    return {
      kw: '',
      driverStatusList: [],
      defaultMsgList: [],
      // driverLocation: [],
      showResumeTimerBtn: false,
      lastUpdateTime: '',
      orderRemindId: null,
    }
  },
  methods: {
    ...mapMutations('hailStateV2', {
      vx_setKw: 'setKw',
      vx_initStore: 'initStore',
      vx_setModalState: 'setModalState',
      vx_setIsDriverMsgModalOpen: 'setIsDriverMsgModalOpen',
    }),
    ...mapActions('hailStateV2', {
      vx_fetchBillList: 'fetchBillList',
      vx_fetchReserveListCount: 'fetchReserveListCount',
      vx_fetchDriverMsgList: 'fetchDriverMsgList',
    }),
    /* 開啟立即單詳細資訊modal */
    async openModal() {
      $('#hailingListModal').modal('show')
      this.vx_setModalState(true)
    },
    /* 立即單modal使用的訊息 */
    async fetchDefaultMsg() {
      try {
        const { result } = await reqDefaultMsg()
        if (result === false) {
          Notification({
            type: 'warning',
            title: '提示',
            message: '找不到資訊',
          })
        } else {
          this.defaultMsgList = JSON.parse(result).map(({ message }, idx) => {
            return {
              value: idx,
              label: message,
            }
          })
        }
      } catch (e) {
        console.error(e)
      }
    },
    searchKw() {
      this.vx_setKw(this.kw)
      this.showResumeTimerBtn = true
      this.$refs.main.timerStop()
      this.vx_fetchBillList()
      this.vx_fetchReserveListCount()
    },
    resumeTimer() {
      this.kw = ''
      this.vx_setKw('')
      this.showResumeTimerBtn = false
      this.$refs.main.resumeTimer()
      this.vx_fetchBillList()
      this.vx_fetchReserveListCount()
    },
    onCloseModal() {
      this.vx_setModalState(false)
    },
    /* 司機即時訊息modal */
    onDriverMsg() {
      this.vx_fetchDriverMsgList()
      this.vx_setIsDriverMsgModalOpen()
    },
    /* 司機即時訊息modal，未來有新的規劃目前暫時註解
    async getMessage() {
      try {
        const { result } = await reqMsg(this.nppMessage, this.pageMessage);
        this.messageList = result.arrayValue;
      } catch (e) {
        console.error(e);
      }
    },
    hideModal() {
      $("#hailingListModal").modal("hide");
    },
    showLoading() {
      this.loader = this.$loading.show({
        container: this.fullPage ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel
      });
    },
    async getMsgList() {
      try {
        const { data } = await reqMsgList(this.npp, this.page);
        this.list = data.result.sort(function (a, b) {
          //順序反轉
          return b.id - a.id;
        });
        this.totalPage = Math.ceil(data.total / this.npp);
        this.loader.hide();
      } catch (e) {
        console.error(e);
      } finally {
        this.loader.hide();
      }
    },
    onDriverMsg() {
      $("#messageListModal").modal("show");
      this.getMsgList();
    },
    hideMsgModal(val) {
      $("#messageListModal").modal("hide");
      setTimeout(() => {
        this.$router.push({ name: "MessageDetail", params: { id: val } });
      }, 500);
    }, */
  },
  /* computed: {
    ...mapState('hailStateV2', {
      vx_isModalOpen: 'isModalOpen',
    }),
  }, */
  mounted() {
    this.vx_initStore()
    this.vx_fetchReserveListCount()
    $('#nav-bill').tab('show')
    this.fetchDefaultMsg()
    /* 後派單提醒 */
    this.orderRemindId = setInterval(() => {
      orderRemind()
    }, 120 * 1000)
  },
  beforeDestroy() {
    clearInterval(this.orderRemindId)
  },
}
</script>

<style scoped>
#right-click-menu {
  background: #fafafa;
  border: 1px solid #bdbdbd;
  box-shadow:
    0 2px 2px 0 rgba(0, 0, 0, 0.14),
    0 3px 1px -2px rgba(0, 0, 0, 0.2),
    0 1px 5px 0 rgba(0, 0, 0, 0.12);
  display: block;
  list-style: none;
  margin: 0;
  padding: 0;
  position: absolute;
  width: 250px;
  z-index: 999999;
}

#right-click-menu li {
  border-bottom: 1px solid #e0e0e0;
  margin: 0;
  padding: 5px 35px;
}

#right-click-menu li:last-child {
  border-bottom: none;
}

#right-click-menu li:hover {
  background: #1e88e5;
  color: #fafafa;
}
</style>



// WEBPACK FOOTER //
// src/pages/hailState/HailStateV2.vue